import { Grid } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useContext } from 'react';
import IGridComponent from '../../../components/grid/i-grid.component';
import { AppContext } from '../../../app-context';
import IButton from '../../../components/button/i-button.component';

const MasterPojoComponent = (props: any) => {
  const appContext = useContext(AppContext);
  const rowData = props.data;

  const columns: GridColDef[] = [
    { field: 'pojoCode', headerName: 'PO/JS Code', filterable: false, sortable: false, width: 200 },
    { field: 'select', headerName: 'Select', filterable: false, sortable: false, width: 200, editable: true, type: 'boolean',
      valueSetter: (value, row) => { row.select = value; return value; }
    }
  ];

  const onCancel = () => {
    props.close('Cancel');
  }

  const onSubmit = () => {
    let count = 0;
    for(let i = 0; i < rowData.length; ++i) {
      count += rowData[i].select ? 1 : 0;
    }
    
    if(count < 0) {
      appContext.setDialogMessage('Master PO/JS should have at least one PO/JS.');
    } else {
      props.close('Submit');
    }
  }

  return <div>
    <Grid container spacing={3}>
      <IGridComponent title='' rows={rowData} columns={columns} getRowId={(row: any) => row.rowId} 
       hideFooterPagination={true} hideFooter={true}/>
    </Grid>
    <div className='btn-panel'>
      <IButton name='submit' label='Submit' color="primary" onActionEvent={onSubmit}/>
      <IButton name='cancel' label='Cancel' color="primary" onActionEvent={onCancel}/>
    </div>
  </div>
}

export default MasterPojoComponent;
